import * as React from 'react'
import algoliasearch from 'algoliasearch/lite'
import { InstantSearch, Configure } from 'react-instantsearch-dom'
import { SEARCH_INDEX, SEARCH_UPDATE_URL_ON_SEARCH_DELAY } from '../constants'
import { SearchState } from 'react-instantsearch-core'
import { connect } from 'react-redux'
import { ApplicationState } from '../../../reducers'
import { history } from '../../../history'
import bind from 'bind-decorator'
import { createQuerystringFromSearchState, searchStateToUrl, querystringToSearchState } from '../utilities'

const searchClient = algoliasearch(
    process.env.REACT_APP_ALGOLIA_APP_ID as string,
    process.env.REACT_APP_ALGOLIA_API_KEY as string
)

type Props = {
    pathname: string
    search: string
}

type State = {
    searchState: SearchState
}

class SearchRoot extends React.Component<Props, State> {
    private debouncedSetState: number | undefined

    constructor(props: Props) {
        super(props)

        this.state = {
            searchState: querystringToSearchState(props.search),
        }
    }

    componentDidMount() {
        this.state.searchState.page = 1
    }

    @bind
    onSearchStateChange(searchState: SearchState) {
        const { pathname } = this.props

        clearTimeout(this.debouncedSetState)

        this.debouncedSetState = window.setTimeout(
            () => history.push(
                searchStateToUrl(pathname, searchState),
                searchState
            ),
            SEARCH_UPDATE_URL_ON_SEARCH_DELAY
        )

        this.setState({ searchState })
    }

    componentWillReceiveProps(nextProps: Props) {
        const { pathname, search } = this.props

        const currentUrl = `${pathname}${search}`
        const nextUrl = `${nextProps.pathname}${nextProps.search}`

        if (nextUrl !== currentUrl) {
            this.setState({ searchState: querystringToSearchState(nextProps.search) })
        }
    }

    render() {
        const { searchState } = this.state

        return (
            <InstantSearch
                searchClient={searchClient}
                indexName={SEARCH_INDEX}
                createURL={createQuerystringFromSearchState}
                onSearchStateChange={this.onSearchStateChange}
                searchState={searchState}
            >
                <Configure
                    hitsPerPage={process.env.REACT_APP_ALGOLIA_HITS_PER_PAGE}
                />
                {this.props.children}
            </InstantSearch>
        )
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        pathname: state.router.location.pathname,
        search: state.router.location.search,
    }
}

const SearchRootWithData = connect(mapStateToProps)(SearchRoot)

export { SearchRoot, SearchRootWithData }
